<script>
	module.exports = {
		props: {
			pills: {
				type: Array,
				required: true
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.pills {
		list-style: none;

		li {
			margin-bottom: 0.5rem;
		}

		.pill {
			padding: $size-xs $size-small;
			color: $c-slate-dark;
			background-color: $c-grey-light;
			vertical-align: top;
			border: 1px solid transparent;
			border-radius: 5px;
			line-height: inherit;

			&:hover {
				border: 1px solid $c-slate;
			}

			.close-icon {
				margin-left: $size-small;
			}
		}
	}
</style>
<template>
	<ul class="pills list-inline">
		<li v-for="pill in pills">
			<button
				class="pill"
				@click="pill.undo">
				<span class="hidden-visually">Remove</span>
				<span class="pill-name">
					<span v-if="pill.isKeywordOption">{{ pill.name }}</span>
					<span
						v-else
						v-html="pill.name"></span>
					<i
						class="close-icon"
						aria-hidden="true"
						>&times;</i
					>
				</span>
			</button>
		</li>
	</ul>
</template>
